import { modelVersions } from '../services/constants';

/**
 * @typedef {Object} TCropOption
 * @property {number} Ec
 * @property {number} PH
 * @property {number} klasse
 * @property {object} streefwaarden_g
 * @property {object} streefwaarden_v
 * @property {boolean} v_g
 * @property {boolean} z_w
 */
/**
 *
 * @param {*} raw
 * @param {*} modelVersion
 * @returns
 */
const readSettings = (raw, modelVersion) => {
    return {
        cropList: Object.entries(raw.crop_options)
            .map(([cropKey, value]) => {
                const cropOption = {
                    crop: cropKey,
                    drainReuse: value.drain_hergebruik,
                    chlorine: value.chlorine,
                    streefwaarden: {},
                };

                if (value.v_g) {
                    cropOption.streefwaarden = {
                        vegetatief: value.streefwaarden_v,
                        generatief: value.streefwaarden_g,
                    };
                } else {
                    cropOption.streefwaarden = value.streefwaarden;
                }

                cropOption.Ec = value.Ec;
                cropOption.PH = value.PH;
                cropOption.klasse = value.klasse;
                cropOption.v_g = value.v_g;
                cropOption.summerWinterAvailable = value.z_w;
                cropOption.cropStages = value.v_g
                    ? ['vegetatief', 'generatief']
                    : null;
                return cropOption;
            })
            .sort((a, b) => a.crop.localeCompare(b.crop)),
        ionParameters: raw.ionParameters,
    };
};

export default readSettings;
